module.exports = __webpack_public_path__ + "static/media/medpro-blue.56736fda.svg";